
import { AgeTagType } from "@/store/types";
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import router from "@/router";

const SurveyModule = namespace("survey");

@Options({
  components: {},
  beforeRouteEnter: (to, from, next) => {
    if (
      from.fullPath !== "/survey/how-old-by-age" &&
      from.fullPath !== "/survey/which-layout"
    ) {
      router.replace("/survey/entrance");
    } else {
      next();
    }
  },
})
export default class SurveyHowOldAge extends Vue {
  @SurveyModule.Getter("byAgeTag")
  private byAgeTag!: AgeTagType;

  @SurveyModule.Action("updateSurveyAge")
  private updateSurveyAge!: (age: number) => Promise<void>;

  @SurveyModule.Action("updateIsWhiteout")
  private updateIsWhiteout!: (isWhiteout: boolean) => Promise<void>;

  public isVisible = false;
  @SurveyModule.Getter("isWhiteout")
  private isWhiteout!: boolean;

  public async mounted() {
    await this.updateIsWhiteout(false);
    window.scrollTo({ top: 0 });
    this.isVisible = true;
  }

  public ageWordList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  public async nextPage(old: string) {
    await this.updateSurveyAge(Number(old));
    await this.updateIsWhiteout(true);
    this.$router.push("/survey/which-layout");
  }

  private get ageBaseValue() {
    let baseValue = 0;

    if (this.byAgeTag === "10S") {
      baseValue = 10;
    } else if (this.byAgeTag === "20S") {
      baseValue = 20;
    } else if (this.byAgeTag === "30S") {
      baseValue = 30;
    } else if (this.byAgeTag === "40S") {
      baseValue = 40;
    } else if (this.byAgeTag === "50S") {
      baseValue = 50;
    } else if (this.byAgeTag === "60S") {
      baseValue = 60;
    } else if (this.byAgeTag === "70S") {
      baseValue = 70;
    } else if (this.byAgeTag === "80S") {
      baseValue = 80;
    } else if (this.byAgeTag === "90S") {
      baseValue = 90;
    }

    return baseValue;
  }

  private get isHundredAndOver() {
    return this.byAgeTag === "100_AND_OVER";
  }

  /**
   * @todo 100歳以上の選択肢はどうする？
   */
  private get isMultiChoices() {
    return (
      this.byAgeTag === "UNDER_10" ||
      this.byAgeTag === "10S" ||
      this.byAgeTag === "20S" ||
      this.byAgeTag === "30S" ||
      this.byAgeTag === "40S" ||
      this.byAgeTag === "50S" ||
      this.byAgeTag === "60S" ||
      this.byAgeTag === "70S" ||
      this.byAgeTag === "80S" ||
      this.byAgeTag === "90S"
    );
  }
}
